<template>
  <div class="row" :key="updateResult">
    <div class="col-12 mb-2">
      <b-btn class="mb-2 mr-2 pull-right" variant="primary" title="Download Report" @click="generatePdf">
        Download Report
      </b-btn>
      <b-btn class="mb-2 mr-2 pull-right" variant="primary" title="Answer Explanation" @click="goToAnswerExplanations()">
        Answer Explanations
      </b-btn>
      <!-- Disabled the below button as faulty analysis was shown on this page -->
      <!-- <b-btn class="mb-2 mr-2 pull-right" variant="primary" title="Assessment Review" @click="gotoAssessmentReview()">
        Assessment Review
      </b-btn> -->
      <!-- <b-btn v-if="quizResultDetail.show_playagain && quizResultDetail.app_type == config.QUIZ_TYPE.quiz && !quizResultDetail.app_name_alias.includes(appNameWithSAT)" variant="primary" class="mb-2 mr-2 pull-right" @click="startQuiz(quizResultDetail.app_id, 'QUIZ_LAYOUT')">
        Play Again
      </b-btn> -->
      <b-btn v-if="quizResultDetail.app_type == testSeriesProductName" variant="primary" class="mb-2 mr-2 pull-right" @click="gotoLink(testSeriesProductName, quizResultDetail.app_id)">
        Testseries Results
      </b-btn>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <div class="col-12">
         <VueHtml2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="(resultOwnerDetails && resultOwnerDetails.user_name + '_' + resultOwnerDetails.user_id.substring(0,10))"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          ref="html2Pdf"
        >
          <div slot="pdf-content">
            <div class="iq-card p-3">
              <!-- <b-button variant="primary" @click="gotoLink()" class="ml-3 float-right">app result V1</b-button> -->
              <div class="row mb-2">
                <div class="col-9">
                  <h2 class="heading"><b>Report Card</b></h2>
                  <h6 class="heading">Student Name:&nbsp;<span class="primary-color pointer" @click="gotoUserProfile(gideUserId)">{{ user_name }}</span></h6>
                  <h6 class="heading">Grade:&nbsp;<span class="primary-color pointer">{{ resultOwnerDetails && resultOwnerDetails.class_name ? resultOwnerDetails.class_name : " - " }}</span></h6>
                  <h6 class="heading">Tested On:&nbsp;<span class="primary-color pointer">{{quizResultDetail.created_on|dateFormat}}</span></h6>
                </div>
              </div>
            </div>

            <div class="iq-card border p-3">
              <div class="row" v-if="showUILoader">
                <!-- Detailed report card Left Section -->
                <div class="col-12 border-bottom pb-2">
                  <h5><b>{{ EXAM_NAME }}</b></h5>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-2 right_bar">
                  <div class="total-score mb-1">
                    <b>Total Score</b><br>
                    <div class="d-flex my-2" style="align-items: center">
                      <span class="primary-color font-size-28 pr-2 mb-0" style="line-height: normal"> <b>{{ totalScore }} / {{ totalScoreRangeMax }}</b></span>
                      <!-- <p class="py-1 px-2 mb-0" syle="line-height: normal;"><small>Score Range:&nbsp;{{ totalScoreRangeMin }} - {{ totalScoreRangeMax }}</small></p> -->
                    </div>
                  </div>
                  <div v-if="showCategoryWiseScores">
                    <b>Section Scores</b><br>
                    <div class="mt-1 total-score" v-for="(quizCategory, index) in FINAL_CHAIN_LIST" :key="index">
                      <div>
                        Category wise Score&nbsp;[&nbsp;<b>{{quizCategory.app_name_alias}}</b>&nbsp;]
                        <div class="d-flex my-2" style="align-items: center" v-if="appNameWithMOCK">
                          <span class="primary-color font-size-28 right_bar pr-2 mb-0" style="line-height: normal">{{ quizCategory.app_score }}</span>
                          <p class="py-1 px-2 mb-0" syle="line-height: normal;">
                          <small v-if="showCategoryWiseScoreRange">Score Range&nbsp;{{ quizCategory.categoryScoreRangeMin ? quizCategory.categoryScoreRangeMin : categoryScoreRangeMin }}&nbsp;<b>{{"\u2014"}}</b>&nbsp;{{ quizCategory.categoryScoreRangeMax ? quizCategory.categoryScoreRangeMax : categoryScoreRangeMax }}</small></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Predicted AP Score: mocks only, not practice -->
                  <div v-if="appCategory.toLowerCase().includes(appNameWithAP.toLocaleLowerCase()) && `${appCategory} ${quizResultDetail.app_name || ''}`.toUpperCase().includes('MOCK')" class="total-score mb-1">
                    <b>Predicted AP Score(Composite Score)</b><br>
                    <div class="d-flex my-2" style="align-items: center">
                      <span class="primary-color font-size-28 pr-2 mb-0" style="line-height: normal"> <b>{{apScore}} / 5</b></span>
                      <!-- <p class="py-1 px-2 mb-0" syle="line-height: normal;"><small>Score Range:&nbsp;{{ totalScoreRangeMin }} - {{ totalScoreRangeMax }}</small></p> -->
                    </div>
                  </div>
                </div><!-- Detailed report card Left Section -->

                <!-- Detailed report card Right Section -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-8">
                  <h5 class="pt-2 pb-2"><b>Knowledge and Skills</b></h5>
                  <p>View your performance across all content domains measured for {{ quizResultDetail.app_category }}</p>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 px-3 mb-2" v-for="(quizCategory, index) in quizResultDetail.chains" :key="index">
                          <div class="d-flex justify-content-between">
                            <div class="iq-header-title">
                              <h4 class="card-title" style="display: inline;">
                                <span>{{quizCategory.app_name_alias.replaceAll("-"," ")}}</span>
                                <!-- Dont Show as the SAT Calculation for Individual Categories will never match the total category score because of Scaled Scoring -->
                                <!--
                                <b-badge style="cursor:pointer; color: #e5252c; background-color: white" class="border mr-2 mb-2 font-weight-normal my-auto" variant="none">
                                  <span>scores:&nbsp;{{ quizCategory.app_score }}</span>
                                </b-badge>
                                -->
                              </h4>
                            </div>
                          </div>

                          <div class="pt-0">
                            <p class="pl-1">
                              Assessment of your performance on this quiz based on different categories</p><br>
                              <div class="col-12 pl-0">
                                <li class="list-group-item" v-for="(item) of quizCategory.qbkCat" :key="item.id">
                                  <div class="d-flex justify-content-between align-items-center mb-1">
                                    <span>{{ item.qbk_category ? item.qbk_category : "-" }}</span>
                                    <span class="text-muted small">
                                      {{ item.correct_answer }} /
                                      {{ item.qbk_category ? item.qbk_category_total_question : item.qbk_total_question }}
                                    </span>
                                  </div>
                                  <div class="progress" style="height: 10px;">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      :style="{ width: getProgress(item) + '%', backgroundColor: colorPalette[index % colorPalette.length] }"
                                      :aria-valuenow="item.correct_answer"
                                      :aria-valuemin="0"
                                      :aria-valuemax="getTotal(item)"
                                    ></div>
                                  </div>
                                </li>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                  </div>
                </div><!-- Detailed report card Right Section -->
              </div>
              <div class="primary-color align-middle text-center" v-else>
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </div>
          </div>
        </VueHtml2pdf>

        <div class="iq-card p-3" v-if="Object.keys(distinctQuizCategories).length == 0">
          <h5>Thank you for attempting the quiz competition, we are evaluating your results. For a detailed report of your performance kindly wait for 48hrs. For any other support please contact <a class="pointer primary-color" href="mailto:support@gide.ai">support@gide.ai</a></h5>
        </div>

        <div class="iq-card" v-if="answerCategoryResult">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title">
                Career Analysis
              </h4>
            </div>
          </div>
          <div class="iq-card-body pt-0 pl-3">
            <p class="pl-1">According to our analysis, following careers suits your interests the best</p><br>
            <div class="col-8 pl-0">
              <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item) of answerCategoryResult" :key="item.id">
                {{ item.answer_category }}
                <span class="badge badge-primary badge-pill">
                  {{item.weightage}}
                </span>
              </li>
            </div>
          </div>
        </div>

        <div v-if="quizResultDetail.chains && quizResultDetail.chains.length > 0 && isSATaTHON_or_MOCK && (userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')" :key="updateResultInsights">
          <QuizResultsInsightsVue v-if="quizResultDetail.app_type != 'testseries'" :key="refreshResultsKey" @emitRefreshResults="emitRefreshResults" :propUserDetails="resultOwnerDetails" :propResultChainList="quizResultDetail.chains" :propAppIsATHON="isSATaTHON_or_MOCK"/>
        </div>

        <!-- <div class="" v-if="quizResultDetail.show_leaderboard && appId && quizResultDetail.total_users && quizResultDetail.app_type == config.QUIZ_TYPE.quiz && !quizResultDetail.app_name_alias.includes(appNameWithSAT)">
          <GideQuizLeaderBoardVue :propAppId="appId" :propToalUsers="quizResultDetail.total_users" :propQuizResultDetail="quizResultDetail"></GideQuizLeaderBoardVue>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { AppResults } from "../../../FackApi/api/appResults.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import SideBarMenu from "../../../Utils/sidebarMenu.js"
// import GideQuizLeaderBoardVue from "../../../components/GideQuizLeaderBoard.vue"
import config from "../../../Utils/config.js"
import userRoles from "../../../FackApi/json/UserRoles.json"
import QuizResultsInsightsVue from "../../../components/QuizResultsInsights.vue"
import { User } from "../../../FackApi/api/user.js"
import VueHtml2pdf from "vue-html2pdf"
import GideProducts from "../../../FackApi/json/GideProducts.json"
import { satModuleScoreCalculation, satScoreCalculation, psat8And9ScoreCalculation, clatScoreCalculation, cuetScoreCalculation, apScoreCalculation } from "../../../Utils/gideprepScoreCalculation.js"

const RESULT_UNPUBLISHED = 2

export default {
  name: "QuizResultView",
  components: {
    // GideQuizLeaderBoardVue,
    QuizResultsInsightsVue,
    VueHtml2pdf
  },
  data () {
    return {
      EXAM_NAME: "",
      refreshResultsKey: 0,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      isMobileDevice: window.__IS__MOBILE_DEVICE__,
      quizCategoryList: [],
      quizResultDetail: {},
      updateResult: 0,
      showUILoader: false,
      updateResultInsights: 0,
      appId: null,
      sideBarItemsList: SideBarMenu.getSideBarMenuObjList(),
      config: config,
      showResultInfoMsg: false, // false: dont Show, true: Show:: info message on top of the page
      distinctQuizCategories: {},
      appCategory: "",
      showCategoryWiseScores: false,
      showCategoryWiseScoreRange: true,
      totalScore: 0,
      apScore: 0,
      totalScoreRangeMin: "",
      totalScoreRangeMax: "",
      categoryScoreRangeMin: "",
      categoryScoreRangeMax: "",
      userRoles: userRoles,
      isSATaTHON_or_MOCK: false,
      appNameWithMOCK: "MOCK-",
      appNameWithTHON: "-THON",
      appNameWithSAT: "SAT-",
      appNameWithPSAT: "PSAT",
      isPSAT: false,
      appNameWithCLAT: "CLAT-",
      appNameWithCUET: "CUET-",
      appNameWithAP: "AP",
      user_name: null,
      resultOwnerDetails: null,
      answerCategoryResult: null,
      resultInfoMsg: "Final results shall be published in 48hrs after end of this competition. You can also access the results from Quiz Result's link on Fun Menu Screen",
      gideUserId: null,
      aprsId: null,
      attemptNo: 1,
      chained_apps_total_score: 0,
      testSeriesProductName: GideProducts.TESTSERIES,
      colorPalette: ["#007bff", "#28a745", "#ffc107", "#dc3545", "#17a2b8", "#6f42c1", "#fd7e14"],
      FINAL_CHAIN_LIST: null,
      SAT_FINAL_CHAIN_LIST: { "English": { "app_name_alias": "English", "app_score": 0, "correct_answer_module1": 0, "correct_answer_total": 0 }, "Maths": { "app_name_alias": "Maths", "app_score": 0, "correct_answer_module1": 0, "correct_answer_total": 0 } }
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  async mounted () {
    socialvue.index()
    this.appId = this.$route.params.appId
    this.gideUserId = this.$route.params.userId
    this.aprsId = this.$route.params.aprsId
    this.attemptNo = this.$route.params.attemptNo

    this.getResultDetail()

    let userViewResp = await User.userView(this, this.gideUserId, this.userData.user_id)
    if (userViewResp.resp_status) {
      this.resultOwnerDetails = userViewResp.resp_data.data
      this.user_name = this.resultOwnerDetails.user_name ? this.resultOwnerDetails.user_name : this.resultOwnerDetails.user_email
    }
  },
  methods: {
    getTotal (item) {
      return item.qbk_category ? item.qbk_category_total_question : item.qbk_total_question
    },
    getProgress (item) {
      const total = this.getTotal(item)
      return total > 0 ? (item.correct_answer / total) * 100 : 0
    },
    /**
     * goto Link
     */
    gotoLink (url, appId) {
      if (url == this.testSeriesProductName) {
        url = `/attempt_list/${appId}/${appId}?gide_user_id=${this.gideUserId}`
      }

      this.$router.push(url)
    },
    /**
     * goto Quiz Add Edit
     */
    gotoAddEditLink (appId) {
      window.open(`/quizBank_list/${appId}`, "_blank")
    },
    /**
     * generate Pdf
     */
    generatePdf () {
      this.$refs.html2Pdf.generatePdf()
    },
    /**
     * goto User Profile
     */
    gotoUserProfile (gideUserId) {
      window.open(`/user/${gideUserId}`)
    },
    /**
     * getResultDetail
     */
    async getResultDetail () {
      let payload = {
        app_id: this.appId,
        attempt: this.attemptNo,
        aprs_id: this.aprsId
      }

      if (this.userData.user_id != this.gideUserId && (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118")) {
        // Gide Admin trying to view and analyse the result. So send the student users id in the payload to get the results from the server
        payload.other_user_id = this.gideUserId
      }

      let appResultViewResp = await AppResults.appResultView(this, payload)
      if (!appResultViewResp.resp_status) {
        ApiResponse.responseMessageDisplay(this, appResultViewResp)
        return
      }

      // Student cannot view the report card while the FRQ of the attempt is under evaluation (deleted = 2), so send to Assessment Review which shows the evaluation message
      const isAdminOrCounselor = this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118"
      if (!isAdminOrCounselor && appResultViewResp.resp_data.data.chains?.some(chainedApp => Number(chainedApp.deleted) === RESULT_UNPUBLISHED)) {
        this.$router.replace(`/app_result_analyse_v1/${this.appId}/${this.gideUserId}/${this.aprsId}?attempt=${this.attemptNo}`)
        return
      }

      appResultViewResp.resp_data.data.user_name = this.userData.user_name
      this.quizCategoryList = appResultViewResp.resp_data_qbkCategoryList
      this.quizResultDetail = appResultViewResp.resp_data.data
      this.appCategory = this.quizResultDetail.app_category
      this.EXAM_NAME = this.appCategory.replace(/(MOCK-).*?(\d+)/, "$1$2")
      // PSAT app categories are not consistent across modules (e.g. "PSAT", "PSAT-Mock-1:..."), so match "PSAT" in any case
      this.isPSAT = this.appCategory.toUpperCase().includes(this.appNameWithPSAT)
      this.isSATaTHON_or_MOCK = this.isPSAT || ((this.appCategory.toLowerCase().includes(this.appNameWithSAT.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithCLAT.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithAP.toLowerCase())) && (this.appCategory.toLowerCase().includes(this.appNameWithMOCK.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithTHON.toLowerCase()) || this.appCategory.toLowerCase().includes(this.appNameWithAP.toLowerCase())))
      // console.log(this.isSATaTHON_or_MOCK, this.appCategory, this.EXAM_NAME, "DDDDD START", this.quizResultDetail)

      this.totalScore = 0

      if (this.isSATaTHON_or_MOCK) {
        // Set the Total Score Min-Max Ranges for all Exams
        if (this.isPSAT || this.appCategory.includes(this.appNameWithSAT)) {
          if (this.isPSAT) {
            // PSAT89 Score range: 240 - 1440 (120 - 720 per section)
            this.totalScoreRangeMin = "240" // before - "160"
            this.totalScoreRangeMax = "1440"

            this.categoryScoreRangeMin = "120"
            this.categoryScoreRangeMax = "720" // before - "1520"
          }
          else {
            // SAT Score range: 400 - 1600 (200 - 800 per section)
            this.totalScoreRangeMin = "400" // before - "200"
            this.totalScoreRangeMax = "1600"

            this.categoryScoreRangeMin = "200"
            this.categoryScoreRangeMax = "800"
          }

          // Collate the total score for each chained app of the Quiz/Exam
          this.quizResultDetail.chains.map((chainedApp) => {
            // IGNORE THE oldMethod, its disabled
            // Below function returns only the no. of correct answers for Eng & Math modules, no exam specific logic is applied here.
            // Hence we are running the same function for both SAT & PSAT.
            satScoreCalculation(chainedApp, this)
          })

          for (let key in this.SAT_FINAL_CHAIN_LIST) {
            if (this.isPSAT) {
              // Execute psat8And9ScoreCalculation function
              psat8And9ScoreCalculation(key, this.SAT_FINAL_CHAIN_LIST[key], this)
              this.totalScore += this.SAT_FINAL_CHAIN_LIST[key].app_score || 0
            }
            else {
              satModuleScoreCalculation(key, this.SAT_FINAL_CHAIN_LIST[key], this)
              this.totalScore += this.SAT_FINAL_CHAIN_LIST[key].app_score || 0
            }
          }
          // console.log("DDDDDD this.SAT_FINAL_CHAIN_LIST", this.quizResultDetail, this.SAT_FINAL_CHAIN_LIST)
          this.FINAL_CHAIN_LIST = this.SAT_FINAL_CHAIN_LIST

          this.showCategoryWiseScores = true
        }
        else if (this.appCategory.includes(this.appNameWithCLAT)) {
          this.totalScoreRangeMin = "(-30)"
          this.totalScoreRangeMax = "120"

          this.categoryScoreRangeMin = "0"
          this.categoryScoreRangeMax = "30"

          this.quizResultDetail.chains.map((chainedApp) => {
            this.totalScore += clatScoreCalculation(chainedApp, this)
          })

          this.FINAL_CHAIN_LIST = this.quizResultDetail.chains

          this.showCategoryWiseScores = true
        }
        else if (this.appCategory.includes(this.appNameWithCUET)) {
          const totalSubjects = this.quizResultDetail.chains?.length ?? 0
          this.totalScoreRangeMin = `(${totalSubjects * -1 * 50})`// Depends on the number of subjects. for 3 subjects -150 and for 5 subjects -250
          this.totalScoreRangeMax = `${totalSubjects * 5 * 50}` // Depends on the number of subjects. for 3 subjects 150 and for 5 subjects 250

          this.categoryScoreRangeMin = "-50"
          this.categoryScoreRangeMax = "250"

          this.quizResultDetail.chains.map((chainedApp) => {
            this.totalScore += cuetScoreCalculation(chainedApp, this)
          })

          this.FINAL_CHAIN_LIST = this.quizResultDetail.chains
        }
        else if (this.appCategory.includes(this.appNameWithAP)) {
          const scoreObj = apScoreCalculation(this.quizResultDetail.chains)

          this.FINAL_CHAIN_LIST = [
            {
              app_name_alias: "MCQ Score",
              app_score: scoreObj?.mcq_stats ? scoreObj.mcq_stats : 0
            },
            {
              app_name_alias: "FRQ Score",
              app_score: scoreObj?.frq_stats ? scoreObj.frq_stats : 0
            }
          ]

          this.apScore = scoreObj?.ap_score ? scoreObj.ap_score : 0

          this.totalScore = scoreObj?.combined_score_obtained ? scoreObj.combined_score_obtained : 0
          this.totalScoreRangeMax = scoreObj?.combined_total_score ? scoreObj.combined_total_score : 0
        }

        this.showCategoryWiseScores = true
        this.showCategoryWiseScoreRange = false
      }

      // Group the exam Wise according to their respective categories. Example For SAT. Group into English & Maths
      this.distinctQuizCategories = {}
      if (this.quizCategoryList) {
        for (let quizCategory of this.quizCategoryList) {
          // console.log(quizCategory.app_name, quizCategory.correct_answer, "DDDDD", quizCategory)
          if (!this.distinctQuizCategories[quizCategory.app_id]) {
            this.distinctQuizCategories[quizCategory.app_id] = [quizCategory]
          }
          else {
            this.distinctQuizCategories[quizCategory.app_id].push(quizCategory)
          }
        }

        if ((this.userData.user_role != "USERROLE11111" && this.userData.user_role != "USERROLE11118") && this.quizResultDetail.show_results == 0) {
          this.distinctQuizCategories = {}
        }
      }

      if (this.quizResultDetail.app_type == config.QUIZ_TYPE.competition && this.$route.params.showResultInfoMsg == "1") {
        this.showResultInfoMsg = true // false: dont Show, true: Show:: info message on top of the page
      }

      if (appResultViewResp.resp_data_psychometric) {
        this.answerCategoryResult = appResultViewResp.resp_data_psychometric
      }

      this.showUILoader = true
      this.updateResultInsights = 1
    },
    /**
     * QuizDetail
    */
    async QuizDetail (quizId) {
      this.$router.push(`/quiz_detail/${quizId}`)
    },
    /**
     * startQuiz
    */
    async startQuiz (examId, pageLayout = null) {
      if (pageLayout) {
        this.$router.push(`/assessment/quiz/${examId}`)
      }
      else {
        this.$router.push(`/question_quiz/${examId}`)
      }
    },
    /**
     * goToQuizList
     */
    goToQuizList () {
      this.$router.push(`/quiz`)
    },
    /**
     * gotoNextAppResult
     */
    gotoNextAppResult (appId) {
      let path = null
      if (this.$route.path.split("/").includes("app_result_view")) {
        path = `/app_result_view/${appId}/${this.gideUserId}/0` // 0=Dont Show info message on top of the page
      }
      else {
        path = `/app_result_view_all/${appId}/${this.gideUserId}/${this.attemptNo}/0` // 0=Dont Show info message on top of the page
      }

      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
    /**
     * emitRefreshResults
     */
    async emitRefreshResults () {
      await this.getResultDetail()
      this.refreshResultsKey++
    },
    /**
     * goToAnswerExplanations
     */
    goToAnswerExplanations () {
      window.open(`/app_result_analyse/${this.quizResultDetail.app_id}/${this.gideUserId}/${this.aprsId}`, "_blank")
    },
    /**
     * goto Assessment Review
     */
    gotoAssessmentReview () {
      window.open(`/app_result_analyse_v1/${this.quizResultDetail.app_id}/${this.gideUserId}/${this.aprsId}`, "_blank")
    }
  },
  watch: {
    "$route.path": function () {
      this.appId = this.$route.params.appId
      this.getResultDetail()
      this.updateResult = Math.random()
    }
  }
}
</script>

<style lang="scss" scoped>
  .heading {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .detail_head {
    font-size: 14px;
    margin-bottom: 0px;
    text-transform: capitalize;
    font-weight: 500;
  }
  .iq-card-body p {
    margin-bottom: 0px;
  }
  .boxs span:first-child {
    color: #fff;
    text-transform: capitalize;
    margin-bottom: 10px;
    font-weight: 500;
  }
  .boxes{
    text-align:left;
  }
  .display_none {
    display: none;
  }
  .right_bar{
    border-right:1px solid #dddddd;
  }
  .total-score{
    border-bottom: 1px dashed #dddddd;
    padding-bottom: 10px;
  }
</style>
